import { createFileRoute } from "@tanstack/react-router";

import {
  guardTasksFeature,
  redirectToClientOverview,
} from "@/core/lib/feature-guards";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_client-tabs/validations",
)({
  beforeLoad: ({ context: { active }, params }) => {
    if (!guardTasksFeature(active).allowed) {
      redirectToClientOverview(params.id);
    }
  },
});
